import { PALETTE } from "../../common/styles/palette"

export const styles = (theme: any) => {
    return {
        listMessagesContainer: {

        },
        chatBox: {
            contentContainerStyle: {
                height: '90%',
                overflow: 'auto',
                // backgroundColor: PALETTE.Chat.Background,
                paddingLeft: '10px',
                paddingRight: '10px',
                paddingBottom: '10px'
            }
        },
        selectedContact: {
            backgroundColor: PALETTE.Contacts.List.SelectedContact.BackGroundColor,
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.SelectedContact.HoveredBackGroundColor
            }
        },
        contact: {
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.HoveredBackGroundColor
            }
        },
        userIcon: {
            minWidth: '0px',
            paddingRight: '10px'
        },
        userNameText: {
            paddingLeft: '20px'
        },
        OnlineCheck: {
            color: "green"
        },
        UserChipUnread: {
            backgroundColor: '#ff6600',
            color: 'white'
        },
        UserChipNoUnread: {
            backgroundColor: 'transparent',
            color: 'inherit'

        },
        BubbleLeft: {
            color: PALETTE.Chat.MessageTextColor,
            backgroundColor: PALETTE.Chat.OtherMessageBackground,
            paddingHorizontal: 10,
            marginBottom: 5,
            marginLeft: 80
        },
        BubbleRight: {
            color: PALETTE.Chat.MessageTextColor,
            marginBottom: 5,
            marginRight: 80,
            backgroundColor: PALETTE.Chat.MyMessageBackground,
            paddingHorizontal: 10
        },
        MsgTimestamp: {
            fontSize: 10,
        },
        btnInvia: {
            backgroundColor: PALETTE.UI.Buttons.Background,
            color: 'white',
            height: '35px',
            lineHeight: '0rem',
            paddingLeft: '0px',
            paddingRight: '0px',
        },
        sendMessageBox: {
            paddingTop: '10px',
            display: "flex",
            alignItems: "flex-end"
        }
    }
}